import WorkoutActionToolbar from './WorkoutActionToolbar';

export default WorkoutActionToolbar;
